import React, { Component } from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider, useSelector, useDispatch } from 'react-redux';
import 'bootstrap';

import store from './stores';
import Home from "./pages/Home";
import Products from "./pages/Products";
import Detail from "./pages/Detail";
import Cart from "./pages/Cart";
import Toast from "./components/Toast";
import { CLEAR_TOAST } from './stores/cart';

// Separate component so it can access Redux inside Provider
const ToastManager = () => {
    const dispatch = useDispatch();
    const toast = useSelector((state) => state.cart.toast);

    if (!toast) return null;

    return (
        <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => dispatch(CLEAR_TOAST())}
        />
    );
};

class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <Router>
                    <div className="App">
                        <Switch>
                            <Route exact path="/" component={Home} />
                            <Route exact path="/products/:type" component={Products} />
                            <Route exact path="/product-detail/:handle" component={Detail} />
                            <Route exact path="/cart" component={Cart} />
                        </Switch>
                        <ToastManager /> {/* 👈 sits outside Switch so it shows on all pages */}
                    </div>
                </Router>
            </Provider>
        );
    }
}

export default App;
